import { render } from "./CIS-Controls-Navigator-Mappings.vue?vue&type=template&id=1e13ec12&scoped=true"
import script from "./CIS-Controls-Navigator-Mappings.vue?vue&type=script&lang=js"
export * from "./CIS-Controls-Navigator-Mappings.vue?vue&type=script&lang=js"

import "./CIS-Controls-Navigator-Mappings.vue?vue&type=style&index=0&id=1e13ec12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e13ec12"]])

export default __exports__